// $(function() {
// alert('hiiiiiiiiiiii');
// });
// featured product thumnails js

  $(document).ready(function() {
    var thumbSwiper = new Swiper('.thumbSwiper', {
      loop: true,
      spaceBetween:25,
      slidesPerView: 5,
      freeMode: true,
      watchSlidesProgress: true,
breakpoints: {
    769: {
      slidesPerView: 5, // Default for larger screens
      spaceBetween: 25
    },
    0: {
      slidesPerView: 4, // Adjust for tablets
      spaceBetween: 18
    }
  }
    });

    var featuredSwiper = new Swiper('.featuredSwiper', {
      loop: true,
      spaceBetween: 10,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      thumbs: {
        swiper: thumbSwiper
      }
    });
  });



var datat_id = $('.addto_cart').attr('var_id');
      $.ajax({
    url: '/cart.js',
    dataType: 'json',
    success: function(cart) {
        let productFound = cart.items.some(item => item.id == datat_id);

        if (productFound) {
      $('.addto_cart.icon_min').show();
      $('.addto_cart.icon_plus').hide();
        }else{
     $('.addto_cart.icon_min').hide();
      $('.addto_cart.icon_plus').show();
}
    },
    error: function(error) {
        console.error('Error fetching the cart:', error);
    }
});




$(document).on("click", ".bundle_wrapper .icons span.plus_icon", function() {
$(this).closest('.custom_icon_wrapper').find('span.minsu_icon').show();
    $(this).hide();
  var id = $(this).attr('var_id');  
$.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: {
        id: id, 
        quantity: 1
    },
    dataType: "json",
    success: function(response) {
    },
    error: function(xhr, status, error) {
       
    }
});
});


$(document).on("click", ".bundle_wrapper .icons span.minsu_icon", function() {
  $(this).closest('.custom_icon_wrapper').find('span.plus_icon').show();
    $(this).hide();
  var id = $(this).attr('var_id');  
$.ajax({
        type: "POST",
        url: "/cart/change.js",
        data: {
            id: id, 
            quantity: 0    
        },
        dataType: "json",
        success: function(response) {
  
        },
        error: function(xhr, status, error) {
        }
    });
});


setTimeout(function(){
$(document).ready(function() {
    let varIds = [];

    $(".plus_icon").each(function() {
        let varId = $(this).attr("var_id");
        if (varId) {
            varIds.push(varId);
        }
    });

    $.getJSON('/cart.js', function(cart) {
        let cartItems = cart.items.map(item => item.id.toString()); 


        $(".plus_icon").each(function() {
            let varId = $(this).attr("var_id");
             if (cartItems.includes(varId)) {
                $(this).hide(); 
                $(this).siblings(".minsu_icon").show();
            }
        });
    });
});
},1000);


 $(document).ready(function(){
   const firstSection = $('.cutom_gltg_tab_section').first();
   firstSection.addClass('active'); // Add active class to first section
   firstSection.find('.para_text_gulf').slideDown(); 
   firstSection.find('.number_gulf_tab_title h3, .number_gulf_tab h3, .para_text_gulf p').css('color', '#000000'); 

   $(document).on('click', '.cutom_gltg_tab_title', function () {
       let parentSection = $(this).closest('.cutom_gltg_tab_section');

       // Remove active class from all and collapse content
       $('.cutom_gltg_tab_section').not(parentSection).removeClass('active').find('.para_text_gulf').slideUp(function () {
           $('.cutom_gltg_tab_section .number_gulf_tab_title h3, .cutom_gltg_tab_section .number_gulf_tab h3, .cutom_gltg_tab_section .para_text_gulf p').css('color', '#a0a0a0');
       });

       // Toggle active class on clicked section
       parentSection.toggleClass('active');

       // Toggle content and color based on active state
       let content = $(this).next('.para_text_gulf');
       content.slideToggle(function () {
           if (content.is(':visible')) {
               parentSection.addClass('active');
               parentSection.find('.number_gulf_tab_title h3, .number_gulf_tab h3, .para_text_gulf p').css('color', '#000000');
           } else {
               parentSection.removeClass('active');
               parentSection.find('.number_gulf_tab_title h3, .number_gulf_tab h3, .para_text_gulf p').css('color', '#a0a0a0');
           }
       });
   });
});


  $(document).on('click', '.cutom_faq_tab_title', function() {
    var $faq = $(this).closest('.custom_faq_main');
    var $faqText = $faq.find('.custom_faq_text');
    var $plusIcon = $faq.find('.plus_icon_faq');
    var $minusIcon = $faq.find('.plus_minus_faq');

    $faqText.slideToggle();
    $plusIcon.toggle();
    $minusIcon.toggle();
});


$(document).on("click", ".rebuy-cart__flyout-item-remove", function() {
    var hrefValue = $(this).closest("li").find(".rebuy-cart__flyout-item-info a").attr("href");
    $(".wrapper_all").each(function() {
        var productHandle = $(this).attr("produict_handle");
        if (hrefValue === productHandle) {
            var new_datat = $(this).find('.custom_icon_wrapper'); 
            $(this).find(".custom_icon_wrapper .plus_icon").show(); 
            $(this).find(".custom_icon_wrapper .minsu_icon").hide();
        }
    });
});
